import React, { useState, useEffect } from "react";
import StatusBadge from "@/components/StatusBadge";
import ReactDOM from "react-dom";
import ImageWithFallback from "@/components/ImageWithFallback";
import { pageLabels } from "@/constant/Pages/page";

const ImagePreviewModal = ({ imageUrl, onClose }) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (imageUrl) {
      setShowModal(true);
    }
  }, [imageUrl]);

  const handleMouseLeave = () => {
    setShowModal(false);
  };

  return ReactDOM.createPortal(
    showModal && (
      <div
        className="fixed inset-0 bg-opacity-50 flex justify-center items-center z-50"
        onMouseLeave={handleMouseLeave}
      >
        <div className="max-w-[80%] max-h-[80%] overflow-auto">
          <div className="relative">
            <img
              src={imageUrl}
              alt="Preview"
              className="max-w-full max-h-[400px] object-contain mx-auto shadow-lg"
            />
            <button
              className="absolute top-2 right-2 bg-slate-200 rounded-full text-black w-6 h-6 flex items-center justify-center"
              onClick={onClose}
            >
              X
            </button>
          </div>
        </div>
      </div>
    ),
    document.body
  );
};
const Columns = () => {
  const [modalImageUrl, setModalImageUrl] = useState(null);

  const handleMouseEnter = (imageUrl) => {
    setModalImageUrl(imageUrl);
  };

  const handleCloseModal = () => {
    setModalImageUrl(null);
  };

  const columns = [
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => <StatusBadge status={row.getValue("status")} />,
    },
    {
      accessorKey: "order",
      header: "Order",
      size: 60,
      cell: ({ row }) => (
        <div className="flex justify-center">{row.getValue("order")}</div>
      ),
    },
    {
      accessorKey: "name",
      header: "Name",
    },
    {
      accessorKey: "sport.name",
      header: "Sport",
      cell: ({ row }) => <div>{row.original.sport?.name || "SP-All"}</div>,
    },
    {
      accessorKey: "page",
      accessorFn: (row) => pageLabels[row.page] || "-",
      header: "Page",
    },
    {
      accessorKey: "image_url",
      header: "Preview",
      cell: ({ row }) => <ImageWithFallback url={row.getValue("image_url")} />,
      enableSorting: false,
    },
  ];

  return columns;
};

export default Columns;
